import { Heading, Text } from '@ritualco/jutsu'
import queryString from 'query-string'
import { useGetWorkspaceInvite } from 'api/endpoints/connections'
import { useContent } from 'lib/content/react'
import { OrganizationType } from 'lib/generated/api'
import { useLocation } from 'lib/router'
import { useStore } from 'state/store'
import { useEffectOnce } from 'utils/react'
import { LoginShell } from './LoginShell'
import { LoginProps } from './types'

export const LoginWorkspaceConnections = (loginProps: LoginProps) => {
  const { formatMessage } = useContent()
  const setRitualLogoType = useStore(state => state.setRitualLogoType)
  const location = useLocation()

  const { connectionId: id } = queryString.parse(location.search)
  const connectionId = (id as string) || ''
  const { status, data } = useGetWorkspaceInvite({ connectionId })

  useEffectOnce(() => {
    setRitualLogoType(OrganizationType.Company)
  })

  if (status === 'loading' || status === 'error' || !data) return null

  return (
    <LoginShell {...loginProps}>
      <Heading fontSize="2xlarge" as="h1">
        {formatMessage({ id: 'pmportal.login.connectionsSignInTitle' })}
      </Heading>
      <Text fontSize="small" color="grayscale.secondary" mt={5}>
        {formatMessage(
          { id: 'pmportal.login.connectionsSignInDescription' },
          {
            organization: data.inviterOrganizationName,
            workspace: data.inviterWorkspaceName,
          }
        )}
      </Text>
    </LoginShell>
  )
}
